module.exports = __webpack_public_path__ + "img/sortImg1-1-2.14f57463.png";